import MappingOriginOption from "~/models/mapping/mappingOriginOption";
import {IMappingOriginOptionObjectModelRelationOpts} from "~/interfaces/mappingInterfaces";
import Model from "~/models/model";
import {ObjectModelRelationType} from "~/enums/objectModelRelationType";
import ObjectModelRelation from "~/models/objectModelRelations/objectModelRelation";
import {Logger} from "~/services/logger";
import MappingOrigin from "~/models/mapping/mappingOrigin";
import RelationIdentifier from "~/models/mapping/relationIdentifier";
import ObjectModel from "~/models/objectModel";

export default class MappingOriginOptionObjectModelRelation<M extends Model = ObjectModel> extends MappingOriginOption<ObjectModelRelation> implements IMappingOriginOptionObjectModelRelationOpts<ObjectModelRelation, M> {
  ORIGIN_TYPE: 'relation' = 'relation'
  model: M;
  inverse_relation: boolean;

  constructor(opts: IMappingOriginOptionObjectModelRelationOpts<ObjectModelRelation, M>) {
    super(opts)    
    if (opts.model) {
      this.model = opts.model
      this.inverse_relation = opts.inverse_relation
    } else {
      Logger.errorOnce('MappingOriginOptionObjectModelRelation', 'Model not provided. Please provide an ObjectModel')
    }
  }

  get type(): 'single' | 'multi' {
    return this.origin.relation_type === ObjectModelRelationType.OneToOne ? 'single' : 'multi'
  }

  get relation(): this['origin'] {
    return this.origin
  }

  get title(): string {
    return this.origin.label_title
  }

  get inverseTitle(): string {
    return this.origin.inverse_label_title
  }

  get id(): string {
    return this.origin.client_id  + ';' + this.model.client_id +`;inverse:${this.inverse_relation}`;
  }

  get originClientId(): string {
    return this.origin.client_id
  }

  addToMappingOrigin(mappingOrigin: MappingOrigin) {
    const attrs = {
      relation_client_id: this.origin.client_id,
      model_client_id: this.model.client_id,
      inverse_relation: this.inverse_relation,
    }
    const alreadyAdded: boolean = mappingOrigin.relationIdentifiers.all.some(ri => {
      return ri.isEqual(attrs)
    })
    if (alreadyAdded) return
    const relationIdentifier = new RelationIdentifier(mappingOrigin).loadFromJson(attrs)
    mappingOrigin.relationIdentifiers.add(relationIdentifier)
    mappingOrigin.trackCreationDeletion(relationIdentifier.client_id, null, relationIdentifier.asJson(), relationIdentifier)
  }
}